import InboxMembersAPI from '../../api/inboxMembers';

const state = {
  records: [],
};

export const getters = {
  getInboxMembers($state) {
    return $state.records;
  },
};

export const mutations = {
  SET_INBOX_MEMBERS($state, members) {
    $state.records = members;
  },
  CLEAR_INBOX_MEMBERS($state) {
    $state.records = [];
  },
};

export const actions = {
  async get({ commit }, { inboxId }) {
    const response = await InboxMembersAPI.show(inboxId);
    commit('SET_INBOX_MEMBERS', response.data.payload);
    return response;
  },
  create(_, { inboxId, agentList }) {
    return InboxMembersAPI.update({ inboxId, agentList });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
